module.exports = __webpack_public_path__ + "img/sos.f3d4edff.jpg";